import AuthService from '../services/AuthService';
import { Base64 } from 'js-base64'; // eslint-disable-line

// const student = localStorage.getItem('student') == null ? {} : JSON.parse(localStorage.getItem('student'))
export const auth = {
  namespaced: true,
  state: {
    student: {
      userAgentDetail: null,
      SINIF: null
    },
    student_id: null,
    class: null,
    isLogged: false,
    error: null,
    fetched: null,
    token: null
  },
  actions: {
    login_with_token({ commit }, token) {
      commit('loginSuccess');
      return AuthService.login_with_token(token).then(
        student => {
          localStorage.setItem('token', token)
          commit('loginSuccess', student)
          return Promise.resolve(student);
        },
        error => {
          commit('loginFailure', error);
          return Promise.reject(error);
        },
      );
    },
    login({ commit }, data) {
      return AuthService.login(data.username, data.password).then(
        student => {
          if (student.token !== undefined) {
            localStorage.setItem('token', student.token)
          }
          commit('loginSuccess', student)
          return Promise.resolve(student)
        },
        error => {
          commit('loginFailure', error)
          return Promise.reject(error)
        },
      );
    },
    logout({ commit }) {
      commit('logoutSuccess');
    }
  },
  mutations: {
    loginSuccess(state, student = false) {
      if (student) {
        state.student = student
        state.student_id = student.OGRENCI_ID
        state.class = student.SINIF
        state.fetched = true
        state.isLogged = true
        state.token = localStorage.getItem('token')
      } else {
        state.student = null
        state.student_id = null
        state.class = null
        state.fetched = false
        state.isLogged = false
      }
    },
    loginFailure(state, error) {
      state.student = null
      state.student_id = null
      state.class = null
      state.error = error.response.data.message
      state.fetched = false
    },
    logoutSuccess(state) {
      state.student = null
      state.student_id = null
      state.class = null
      state.fetched = false
      state.isLogged = false
      state.token = null
    }
  }
};